import { render, staticRenderFns } from "./AddNotaPersona.vue?vue&type=template&id=f04c2f5c&scoped=true"
import script from "./AddNotaPersona.vue?vue&type=script&lang=js"
export * from "./AddNotaPersona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04c2f5c",
  null
  
)

export default component.exports